import React, { FC, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { Container } from "@material-ui/core";
import ButtonComponent from "../../components/ButtonComponent";
import TextFieldComponent from "../../components/TextFieldComponent";
import Title from "../../components/Title";
import AlertComponent from "../../components/Alert/AlertComponent";
import ScreenLoader from "../../components/ScreenLoader";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import UserModel from "../../models/user-model";
import * as Validations from "../../helpers/validations";
import { utilities } from "../../helpers/utilities";
import {
  renewPassword,
  clearIsSend,
} from "../../flux/actions/renewPassword-actions";
import { RenewPasswordReducerState } from "../../flux/reducers/renewPassword-reducer";
import { useStyles } from "./styles";

const RenewPassword: FC = () => {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({ email: "" });
  const [emailSent, setEmailSent] = useState(false);
  const user: UserModel = useSelector((state: any) => state.authReducer.user);

  const dispatcher = useDispatch();
  const renewPasswordSelector: RenewPasswordReducerState = useSelector(
    (state: any) => state.renewPassword
  );


  useEffect(() => {
    dispatcher(clearIsSend());
  }, [dispatcher]);

  useEffect(() => {
    if (user && user.id) {
      window.location.href = "/";
    }
  }, [user]);

  useEffect(() => {
    if (renewPasswordSelector.isSend && !renewPasswordSelector.error)
      setEmailSent(true);
    else setEmailSent(false);
  }, [renewPasswordSelector.isSend]);

  useEffect(() => {
    if (renewPasswordSelector.error) {
      setErrors({ ...errors, email: renewPasswordSelector.error });
    } else {
      setErrors({ email: "" });
    }
  }, [renewPasswordSelector.error]);

  //HandleSubmit function//
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const emailErrors = Validations.validate(
      [Validations.required, Validations.emailText],
      email
    );

    setErrors({
      email: emailErrors,
    });

    const correctedEmail = email.trim();

    if (emailErrors) return;

    const randomPassword = Math.floor(100000 + Math.random() * 900000);
    const passwordCorrected = randomPassword.toString();

    const passwordWithSpaces = passwordCorrected.split("").join("   ");

    dispatcher(
      renewPassword(
        {
          user: {
            email: correctedEmail,
            password: passwordCorrected,
          },
        },
        passwordWithSpaces
      )
    );
  };

  return (
    <Container component="main" maxWidth="sm">
      <ScreenLoader isOpen={renewPasswordSelector.loading} />
      <form onSubmit={handleSubmit} className={classes.form}>
        <div className={classes.headerSection}>
          <Link to="/login" className={classes.arrowBack}>
            <ArrowBackIcon />
          </Link>
          <Title value="Renovar contraseña" />
        </div>
        <TextFieldComponent
          disabled={emailSent}
          label={"Email"}
          type="text"
          onChange={(e) => {
            setEmail(e.target.value);
            setErrors({ ...errors, email: "" });
          }}
        />

        <ButtonComponent
          disabled={emailSent}
          value="Enviar"
          type="submit"
          color="secondary"
          variant="contained"
        />
        {emailSent && (
          <AlertComponent severity="success">
            Se envió un correo electrónico al email proporcionado con la nueva
            contraseña
          </AlertComponent>
        )}
        {errors.email && (
          <AlertComponent severity="error">
            {utilities.returnErrorFlag(errors.email)
              ? errors.email
              : renewPasswordSelector.error}
          </AlertComponent>
        )}
      </form>
    </Container>
  );
};

export default RenewPassword;
